import { PlusOutlined } from '@ant-design/icons'
import { Button, Menu, message, Modal } from 'antd'
import { runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useState } from 'react'
import { Link, useHistory, withRouter } from 'react-router-dom'
import AccessControlAction from '../../../components/AccessControlAction'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import DashboardLayout from '../../../layouts/DashboardLayout'
import ApprovalTemplateCreate from '../ApprovalTemplate/ApprovalTemplateCreate'
import { ACL_ACTION_TYPE } from '../../../constants'
import AppPageHeader from '../../../components/AppPageHeader'
import { AddCircleOutlineIcon } from '../../../components/AppIcon'

const AdministrativeManagementLayout = props => {
  const { selectedKey, children, title } = props
  const { authenticationStore, proposalTypeStore } = props
  const { isAccountAdmin, isSuperAdmin } = authenticationStore
  const history = useHistory()
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)

  // useEffect(() => {
  //   if (isAccountAdmin || isSuperAdmin || !authenticationStore.currentUser) {
  //     return
  //   }

  //   history.replace('/')
  //   message.error('Bạn không có quyền truy cập trang này!')
  // }, [authenticationStore.currentUser])

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
    if (!bool) {
      runInAction(() => {
        props.approvalTemplateStore.approvalTemplateLevels = []
      })
    }
  }

  return (
    <DashboardLayout>
      {title}
      <AppPageHeader
        title="Quản lý hành chính"
        addon={
          <>
            {selectedKey === 'approval-templates' && (
              // <AccessControlAction
              // aclActionType={ACL_ACTION_TYPE.create__PROPOSAL_ADVANCE}
              // >
              <Button
                onClick={handleToggleCreateModal(true)}
                type={'primary'}
                className="custom-ant-button icon-btn "
                icon={
                  <AddCircleOutlineIcon
                    style={{ color: '#fff', width: 16, height: 16 }}
                  />
                }>
                Tạo mới
              </Button>
              // </AccessControlAction>
            )}
            {selectedKey === 'proposal-type' && (
              // <AccessControlAction
              // aclActionType={ACL_ACTION_TYPE.create__PROPOSAL_ADVANCE}
              // >
              <Button
                onClick={() => {
                  proposalTypeStore.showCreateModal = true
                }}
                type={'primary'}
                className="custom-ant-button icon-btn "
                icon={
                  <AddCircleOutlineIcon
                    style={{ color: '#fff', width: 16, height: 16 }}
                  />
                }>
                Tạo mới loại hành chính
              </Button>
              // </AccessControlAction>
            )}
          </>
        }
      />

      <div>
        <Menu
          className="custom-menu-tab"
          mode="horizontal"
          selectedKeys={[selectedKey]}
          style={{ marginBottom: 16 }}>
          {/* </AccessControlAction> */}
          <Menu.Item key="approval-templates">
            <Link to={'/administrative-management/approval-templates'}>
              Cấp duyệt
            </Link>
          </Menu.Item>
          {/* <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.menu__LOAI_HANH_CHINH}> */}
          <Menu.Item key="proposal-type">
            <Link to={'/administrative-management/proposal-type'}>
              Loại hành chính
            </Link>
          </Menu.Item>
          <Menu.Item key="content-template">
            <Link to={'/administrative-management/content-template'}>
              Văn bản mẫu
            </Link>
          </Menu.Item>
        </Menu>
        {children}
      </div>

      <Modal
        wrapClassName="custom-modal-wrapper"
        width={1000}
        title={'Tạo mới cấp duyệt'}
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ApprovalTemplateCreate onCancel={handleToggleCreateModal(false)} />
        )}
      </Modal>
    </DashboardLayout>
  )
}

export default memo(
  withRouter(
    inject(
      'authenticationStore',
      'approvalTemplateStore',
      'proposalTypeStore'
    )(observer(AdministrativeManagementLayout))
  )
)
